/* Finding Wonderland — collection page behavior
   Sparkle field + per-tile bursts + hover glitter sound + wishlist (localStorage). */
(function () {
  /* ---- Glitter hover sound (synthesized, no audio file needed) ---- */
  var AC = null, lastGlitter = 0;
  function audioCtx() {
    if (AC === null) {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      AC = Ctx ? new Ctx() : false;
    }
    if (AC && AC.state === 'suspended') { try { AC.resume(); } catch (e) {} }
    return AC;
  }
  // Browsers require a user gesture before audio; prime the context on first interaction.
  ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function primer() { audioCtx(); }, { once: true, passive: true });
  });
  function playGlitter() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var now = Date.now();
    if (now - lastGlitter < 90) return; // throttle
    lastGlitter = now;
    var ctx = audioCtx();
    if (!ctx || ctx.state !== 'running') return;
    var t0 = ctx.currentTime;
    // A quick shimmer: several high bell-like partials, staggered, fast decay.
    var freqs = [1568, 2093, 2637, 3136, 3520]; // G6, C7, E7, G7, A7 — bright & twinkly
    freqs.forEach(function (f, i) {
      var start = t0 + i * 0.045 + Math.random() * 0.01;
      var osc = ctx.createOscillator();
      var gain = ctx.createGain();
      osc.type = 'triangle';
      osc.frequency.setValueAtTime(f * (0.99 + Math.random() * 0.02), start);
      var peak = 0.06 - i * 0.008;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(Math.max(peak, 0.012), start + 0.012);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.32);
      osc.connect(gain).connect(ctx.destination);
      osc.start(start);
      osc.stop(start + 0.36);
    });
  }

  function init(root) {
    if (!root || root.__fwInit) return;
    root.__fwInit = true;

    var COL_HEX = { white: '#fff', lime: '#E5FC55', pink: '#FFA4CC' };
    var GLOW = {
      white: '0 0 16px rgba(255,255,255,1),0 0 34px rgba(229,252,85,1),0 0 60px rgba(255,164,204,1)',
      lime: '0 0 16px rgba(229,252,85,1),0 0 44px rgba(229,252,85,1),0 0 70px rgba(229,252,85,.85)',
      pink: '0 0 16px rgba(255,164,204,1),0 0 44px rgba(255,164,204,1),0 0 70px rgba(255,164,204,.85)'
    };
    var srnd = function (n, seed) { var v = Math.abs(Math.sin((n + 1) * seed)) * 10000; return v - Math.floor(v); };

    /* ---- Background sparkle field ---- */
    var field = root.querySelector('.fw-starfield-inner');
    if (field) {
      var amount = parseInt(root.getAttribute('data-sparkle-amount') || '27', 10);
      if (amount > 0) amount = Math.max(amount, 22);
      var mode = (root.getAttribute('data-sparkle-color') || 'Mixed').toLowerCase();
      var frag = document.createDocumentFragment();
      for (var i = 0; i < amount; i++) {
        var s = document.createElement('span');
        var key = ['white', 'lime', 'pink'].indexOf(mode) >= 0 ? mode : ['white', 'white', 'lime', 'pink'][i % 4];
        s.className = 'fw-bgstar' + (key === 'lime' ? ' lime' : key === 'pink' ? ' pink' : '');
        s.textContent = i % 3 === 0 ? '\u2727' : '\u2726';
        s.style.top = (srnd(i, 12.9) * 93 + 3).toFixed(1) + '%';
        s.style.left = (srnd(i, 78.2) * 94 + 2).toFixed(1) + '%';
        s.style.fontSize = Math.round(13 + srnd(i, 3.1) * 15) + 'px';
        s.style.setProperty('--tw', (3.2 + srnd(i, 5.5) * 3.4).toFixed(1) + 's');
        frag.appendChild(s);
      }
      field.appendChild(frag);
    }

    /* ---- Per-tile sparkle burst (unique per card) ---- */
    var tiles = root.querySelectorAll('.fw-tile');
    var bmode = (root.getAttribute('data-sparkle-color') || 'Mixed').toLowerCase();

    // Burst lives inside each tile, BEHIND the card (z-index 0), so sparkles
    // peek out from underneath the product card on hover.
    tiles.forEach(function (tile, idx) {
      var burst = tile.querySelector('.fw-burst');
      if (!burst) return;
      burst.innerHTML = '';
      var seed = (idx + 1) * 13.37 + 7.1;
      var n = 16;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var ang = (i / n) * Math.PI * 2 + (srnd(i, seed) - 0.5) * 1.1;
        var dist = 130 + srnd(i, seed * 1.7) * 130;
        var bx = Math.round(Math.cos(ang) * dist);
        var by = Math.round(Math.sin(ang) * dist);
        var size = Math.round(30 + srnd(i, seed * 2.3) * 26);
        var dur = (0.9 + srnd(i, seed * 3.1) * 0.8).toFixed(2);
        var delay = (srnd(i, seed * 4.9) * 0.28).toFixed(2);
        var rot = Math.round((srnd(i, seed * 5.5) - 0.5) * 540);
        var key = ['white', 'lime', 'pink'].indexOf(bmode) >= 0 ? bmode : ['white', 'white', 'lime', 'pink'][Math.floor(srnd(i, seed * 6.7) * 4)];
        var sp = document.createElement('span');
        sp.textContent = srnd(i, seed * 7.3) > 0.5 ? '\u2726' : '\u2727';
        sp.style.cssText = 'font-size:' + size + 'px;color:' + COL_HEX[key] + ';text-shadow:' + GLOW[key] +
          ';--bx:' + bx + 'px;--by:' + by + 'px;--rot:' + rot + 'deg;animation-delay:' + delay + 's;animation-duration:' + dur + 's';
        frag.appendChild(sp);
      }
      burst.appendChild(frag);
      tile.addEventListener('mouseenter', playGlitter);
    });

    /* ---- Wishlist (localStorage) ---- */
    var WKEY = 'fw-wishlist';
    var wished = {};
    try { wished = JSON.parse(localStorage.getItem(WKEY) || '{}'); } catch (e) { wished = {}; }
    root.querySelectorAll('.fw-wish').forEach(function (btn) {
      var id = btn.getAttribute('data-wish');
      if (wished[id]) { btn.classList.add('is-wished'); btn.textContent = '\u2665'; }
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        wished[id] = !wished[id];
        btn.classList.toggle('is-wished', !!wished[id]);
        btn.textContent = wished[id] ? '\u2665' : '\u2661';
        try { localStorage.setItem(WKEY, JSON.stringify(wished)); } catch (e2) {}
      });
    });
  }

  function boot() { document.querySelectorAll('.fw-shop').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Shopify theme editor re-render
  document.addEventListener('shopify:section:load', function (e) {
    (e.target.querySelectorAll ? e.target.querySelectorAll('.fw-shop') : []).forEach(init);
  });
})();
